import {Component, Directive, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'cyb-main',
  template: `<main class="cyb-main-container">
  <ng-content></ng-content>
</main>
`,
  styles: [`.cyb-main{box-sizing:border-box;display:block}.cyb-main-container{max-width:1600px;min-width:750px;width:95%;box-sizing:border-box;display:block;padding-bottom:60px;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}`],
  encapsulation: ViewEncapsulation.None,
  host: {'class': 'cyb-main'}
})
export class CybMainComponent {}
